module.exports = __webpack_public_path__ + "img/salvador.f4ad0637.png";